"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AddNoteButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const useDevice_1 = require("../../../hooks/useDevice");
const AppText_1 = require("../../../component/AppText");
const colors_1 = require("../../../common/colors");
function AddNoteButton({ text, isCompactSize, ...restProps }) {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { ...restProps, children: (0, jsx_runtime_1.jsxs)(react_native_linear_gradient_1.default, { colors: colors_1.Colors.CTA_GRADIENT_1, locations: [-0.4191, 0.5466], useAngle: true, angle: 222, style: [
                styles.container,
                (isMobileScreen || isCompactSize) && styles.mobileContainer,
                text && styles.containerText,
            ], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: (isMobileScreen || isCompactSize) && styles.iconContainerMobile, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, color: colors_1.Colors.NEUTRAL_00, size: (isMobileScreen || isCompactSize) ? 16 : 15 }) }), text && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.text, children: "New Note" }))] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        padding: 4.5,
        borderRadius: 38,
    },
    mobileContainer: {
        gap: 4,
        flexDirection: 'row',
        padding: 6,
    },
    containerText: {
        paddingHorizontal: 12
    },
    iconContainerMobile: {
        padding: 2,
    },
    text: {
        color: colors_1.Colors.NEUTRAL_00,
        lineHeight: 20,
    },
});
